import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="w-full bg-[#FAF6F0] py-20 px-6 md:px-8" data-id="element-167">
      <div className="max-w-3xl mx-auto" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-169">
          <h2 className="font-serif text-3xl md:text-4xl text-[#1B2141] mb-8 text-center" data-id="element-170">
            ¿Esto te pasa?
          </h2>

          <p className="text-xl text-[#2D2D2D] leading-relaxed mb-8" data-id="element-171">
            Te duermes… y horas después abres los ojos. No es que estés
            “descansando” despierta.
            <span className="font-bold block mt-2" data-id="element-172">
              Estás despierta de verdad.
            </span>
          </p>

          <div className="bg-white p-8 rounded-xl shadow-sm border-l-4 border-[#C9A96E] mb-10" data-id="element-173">
            <p className="text-lg text-[#2D2D2D] mb-4 font-medium" data-id="element-174">
              Tu mente empieza a hacer ruido:
            </p>
            <ul className="space-y-3" data-id="element-175">
              {['Pendientes', 'Familia', 'Salud', 'Dinero', '“Mañana voy a estar fatal”'].map((item, index) => <li key={index} className="flex items-center text-[#4A4A4A] text-lg" data-id="element-176">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#C9A96E] mr-3" data-id="element-177"></span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="text-center" data-id="element-178">
            <p className="text-lg text-[#2D2D2D] mb-4" data-id="element-179">
              Y lo peor: miras el reloj (aunque sea una vez) y el cuerpo entra
              en alerta. Si esto se repite, terminas viviendo en un ciclo:
            </p>
            <div className="inline-block bg-[#1B2141] text-[#FAF6F0] px-6 py-3 rounded-lg font-medium text-lg shadow-md" data-id="element-180">
              noche mala → día pesado → noche con miedo
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}